import styled from '@emotion/styled'
import { FormFieldHeight, colors } from '../../../configs/styles/config'
import { Field, FieldProps } from 'formik'

type Props = {
  type: 'text' | 'password' | 'email' | 'number'
  id: string
  name: string
  placeholder?: string
  width?: string
  value?: string | null | number | undefined
  padding?: string
  error?: boolean | string
  onChange?: (event: any) => void
  max?: any
  maxLength?: string
  disabled?: boolean
  min?: any
  autoComplete?: 'on' | 'off' | 'new-password'
}

const Input = styled.input<{ width: string }>`
  border: 1px solid ${(props) => (props.error ? colors.uguRed : 'lightgray')};
  border-radius: 10px;
  padding: ${(props) => (props.padding ? props.padding : '0 0.7rem')};
  height: ${FormFieldHeight.large};
  width: ${(props) => props.width};
  box-sizing: border-box;
  :focus {
    /* border: 2px solid #7181ff; */
  }
`

const TextField = ({
  type,
  id,
  name,
  placeholder = '',
  width = '20rem',
  padding,
  error,
  max,
  maxLength,
  disabled = false,
  min,
  autoComplete = 'on',
  ...rest
}: Props) => {
  return (
    <Field name={name} type={type}>
      {({ field }: FieldProps) => {
        return (
          <Input
            placeholder={placeholder}
            type={type}
            width={width}
            id={id}
            padding={padding}
            error={error}
            disabled={disabled}
            b
            {...field}
            max={max}
            className="focus:ring-2 ring-uguBrightPurple"
            min={min}
            maxLength={maxLength ? maxLength : ''}
            autoComplete={autoComplete}
            {...rest}
          />
        )
      }}
    </Field>
  )
}
export default TextField
